module.exports = __webpack_public_path__ + "img/loading_s.13c4aae7.svg";